exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.item img[data-v-2a60751c] {\n  width: 0.75rem;\n  margin-top: -0.15rem;\n  margin-right: 0.25rem;\n}", ""]);

// exports
